import React from 'react';
import { Base } from './Base';
import { Text, TextLink } from './Text';
import { Link } from 'react-router-dom';
import { ActionIcon, ActionIconGrey } from './icons';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';
import { formatDate } from 'src/utils/misc';
import { getDestinationType, getObjectLink } from './util';

interface EActionCompletedProps {
  showDate?: string;
  owner: string;
  action: {
    id: string;
    notes: string;
  };
  object: {
    id: string;
    name: string;
    type: string;
    assessmentId?: string;
  };
  truncate?: boolean;
  isPast?: boolean;
  overdue?: boolean;
}

export const EActionCompleted: React.FC<EActionCompletedProps> = ({
  showDate,
  action,
  object,
  truncate,
  isPast,
  overdue,
}) => {
  return (
    <Base
      iconComponent={isPast ? <ActionIconGrey /> : <ActionIcon />}
      constentComponent={
        <Text nowrap={truncate} $isPast={isPast}>
          {showDate && <Text className={`sdate ${overdue ? 'sdate--past' : ''}`}>{formatDate(showDate)}</Text>}
          Action{' '}
          <Link
            to={`${getObjectLink(object)}#actions`}
            onClick={() =>
              mpEvent(MPEvents.Link, {
                source: {
                  value: ['Timeline'],
                },
                destination: {
                  value: [getDestinationType(object.type)],
                  params: {
                    id: object.id,
                  },
                },
                tags: ['TIMELINE', 'ACTIONS'],
              })
            }
          >
            <TextLink>{action.notes}</TextLink>
          </Link>{' '}
          {isPast ? 'was completed' : 'completed'}
        </Text>
      }
    />
  );
};
